export default {
  "header": "We believe in simplifying the lives of parents and celebrating real life with kids.",
  "sections": [
    {
      "title": "KIDS ARE AWESOME",
      "body": "And we want to celebrate them! Quirks, preferences and all—with clothes that express who they are as individuals."
    },
    {
      "title": "PARENTS ARE SUPERHEROES",
      "body": "We’ll make your life easier, so you can get back to being the best snack-schlepper, soccer-practice-chauffeur..."
    },
    {
      "title": "SHOPPING SHOULD BE EASY",
      "body": "You shouldn’t have to go to a million sites and stores to find awesome clothes you AND your kids will love."
    }
  ],
  "footer": "BECAUSE IT’S MORE FUN WHEN EVERYONE WINS!"
}



// WEBPACK FOOTER //
// ./src/components/aboutUs/defaultProps.js